import { ADD_HISTORY } from '../constants';

export const setHistory = date => async (dispatch) => {
  dispatch({
    type: ADD_HISTORY,
    payload: date,
  });
};
